import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyUserInformationComponent } from './myuserinformation.component';
import { ListboxModule } from 'primeng/listbox';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectModule } from 'primeng/select';
// import { TabViewModule } from 'primeng/tabview'; // Commented out due to PrimeNG v20 provider issues
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';



@NgModule({
    imports: [
        ButtonModule,
        CommonModule,
        CheckboxModule,
        SelectModule,
        FormsModule,
        ListboxModule,
        // TabViewModule,
        TableModule,
        MyUserInformationComponent
    ],
    exports: [MyUserInformationComponent]
})
export class MyUserInformationModule { }
